import { displayModal, hideModal, removeEvaluationFormPopupOpenList, selectCurrentEpisode, selectEvaluationFormPopupOpenList } from "@adm-media/adam-store-plugin";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useAppDispatch } from "../store";
import { EVALUATION_MODAL } from "../components/modals";
import { exitFullScreenMode } from "../utils/player";
import { useIsEvaluationFormAvailable } from "./useIsEvaluationFormAvailable";
export var useIsEvaluationFormPopupOpen = function () {
    var _a;
    var dispatch = useAppDispatch();
    var selectedEpisodeId = useSelector(selectCurrentEpisode).id;
    var efPopupTriggeredList = useSelector(selectEvaluationFormPopupOpenList);
    var _b = useState(), eFPopupCountdownStartAt = _b[0], setEFPopupCountdownStartAt = _b[1];
    var _c = useState(), eFPopupCountdownInSecondsDuration = _c[0], setEFPopupCountdownDuration = _c[1];
    var isEvaluationFormAvailable = useIsEvaluationFormAvailable().isEvaluationFormAvailable;
    var evaluationFormFromUrl = (_a = new URLSearchParams(window.location.search)) === null || _a === void 0 ? void 0 : _a.get("efo");
    useEffect(function () {
        if (!evaluationFormFromUrl || !isEvaluationFormAvailable)
            return;
        dispatch(displayModal({ name: EVALUATION_MODAL }));
    }, [evaluationFormFromUrl, isEvaluationFormAvailable]);
    useEffect(function () {
        if (!efPopupTriggeredList || efPopupTriggeredList.length === 0)
            return;
        var isEFPopupOpenedByPusher = efPopupTriggeredList.find(function (ef) { return ef.episode_id === selectedEpisodeId; });
        // We pass the values only if both fields are present
        if ((isEFPopupOpenedByPusher === null || isEFPopupOpenedByPusher === void 0 ? void 0 : isEFPopupOpenedByPusher.countdown_start_at) && (isEFPopupOpenedByPusher === null || isEFPopupOpenedByPusher === void 0 ? void 0 : isEFPopupOpenedByPusher.countdown_duration)) {
            setEFPopupCountdownStartAt(isEFPopupOpenedByPusher === null || isEFPopupOpenedByPusher === void 0 ? void 0 : isEFPopupOpenedByPusher.countdown_start_at);
            setEFPopupCountdownDuration(isEFPopupOpenedByPusher === null || isEFPopupOpenedByPusher === void 0 ? void 0 : isEFPopupOpenedByPusher.countdown_duration);
        }
        if (isEFPopupOpenedByPusher === null || isEFPopupOpenedByPusher === void 0 ? void 0 : isEFPopupOpenedByPusher.ef_open) {
            exitFullScreenMode();
            dispatch(displayModal({ name: EVALUATION_MODAL }));
        }
        else if ((isEFPopupOpenedByPusher === null || isEFPopupOpenedByPusher === void 0 ? void 0 : isEFPopupOpenedByPusher.episode_id) && !(isEFPopupOpenedByPusher === null || isEFPopupOpenedByPusher === void 0 ? void 0 : isEFPopupOpenedByPusher.ef_open)) {
            // We cleanup the state, this because we can't track when user manually close the popup
            dispatch(removeEvaluationFormPopupOpenList(isEFPopupOpenedByPusher));
            dispatch(hideModal({ name: EVALUATION_MODAL }));
        }
    }, [efPopupTriggeredList, selectedEpisodeId]);
    return { eFPopupCountdownStartAt: eFPopupCountdownStartAt, eFPopupCountdownInSecondsDuration: eFPopupCountdownInSecondsDuration };
};
